<div class="card text-center border shadow-sm p-3 h-100">
  <img
    [src]="iconSrc"
    alt="icon"
    class="card-img-top mx-auto img-color"
    style="width: 60px; height: 60px"
  />
  <div class="card-body">
    <h5 class="card-title headinigBL">{{ title }}</h5>
    <p class="card-text vtext">{{ description }}</p>
  </div>
</div>
